import GooglePay from 'features/moveMoney/screens/GooglePay/GooglePay';

export default GooglePay;
